import * as React from 'react';
import { ApButtonMain, colors } from '@alixpartners/ui-components';
import styled from 'styled-components';
import noInitiativesImage from 'assets/images/noInitiatives.png';
import noWavesImage from 'assets/images/noWaves.png';
import noDataAvailableForFiltersImage from 'assets/images/noDataAvailableForFilters.png';

export const Wrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;

	${({ isUpdating }) => (isUpdating ? `opacity: 0.8` : '')};
`;

export const Content = styled.div`
	height: 100%;
	overflow: auto;
	width: 100%;
	padding: 32px;
	background: ${colors.greyBg};
`;

export const LoadingContainer = styled.div`
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	z-index: 10;
	background-color: rgba(255, 255, 255, 0.8);
`;

export const NoDataMessageWrapper = styled.div`
	background-image: url(${({ isWaves, isReset }) =>
		isWaves
			? noWavesImage
			: isReset
				? noDataAvailableForFiltersImage
				: noInitiativesImage});
	background-repeat: no-repeat;
	background-position: center 0;
	height: 650px;
	padding: 0 8px;
	display: flex;
	flex-direction: column;
	position: absolute;
	top: 20%;
	right: 0;
	left: 0;
	bottom: 0;
	background-size: 460px;
`;

export const NoDataMessageTitle = styled.div`
	margin-top: 375px;
	color: ${colors.grey8};
	font-size: 33px;
	font-style: normal;
	font-weight: 500;
	line-height: 31px;
	letter-spacing: 0.3px;
	text-align: center;
`;

export const NoDataMessageText = styled.div`
	color: ${colors.grey5};
	font-size: 13px;
	font-style: normal;
	font-weight: 400;
	line-height: 19px;
	letter-spacing: 0.3px;
	text-align: center;
	height: 64px;
	margin: 36px auto 0;
	width: 310px;
`;

export const NoDataMessage = ({ onCreate, onReset, isWaves, isReset }) => {
	const title = isReset
		? 'No data available for this combination of filters'
		: 'It’s time to create opportunities';
	const button = isReset ? (
		<ApButtonMain iconName="baseline_undo" onClick={onReset}>
			Reset filters
		</ApButtonMain>
	) : (
		<ApButtonMain iconName="baseline_add" onClick={onCreate}>
			Create initiative
		</ApButtonMain>
	);

	return (
		<NoDataMessageWrapper isWaves={isWaves} isReset={isReset}>
			<NoDataMessageTitle>{title}</NoDataMessageTitle>
			<NoDataMessageText>{button}</NoDataMessageText>
		</NoDataMessageWrapper>
	);
};

export const NoCategorySidebarDataMessage = ({
	onCreate,
	onReset,
	isWaves,
	isReset,
}) => {
	const title = isReset
		? 'No data available for this combination of filters'
		: 'It’s time to create categories';
	const button = isReset ? (
		<ApButtonMain iconName="baseline_undo" onClick={onReset}>
			Reset filters
		</ApButtonMain>
	) : (
		<ApButtonMain iconName="baseline_add" onClick={onCreate}>
			Add Categories
		</ApButtonMain>
	);

	return (
		<NoDataMessageWrapper isWaves={isWaves} isReset={isReset}>
			<NoDataMessageTitle>{title}</NoDataMessageTitle>
			<NoDataMessageText>{button}</NoDataMessageText>
		</NoDataMessageWrapper>
	);
};
